import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';
import { BodyCopy } from '@xingternal/typography';
import { Styled } from './common.style';
export const FlagLoading = () => (_jsxs(Styled.LoadingContainer, { children: [_jsx(Styled.LoadingIconContainer, { children: _jsx(DotLoadingIndicator, {}) }), _jsx(BodyCopy, { size: "small", lineHeight: "dense", noMargin: true, children: _jsx(FormattedMessage, { id: "USER_FLAG_LOADING" }) })] }));
//# sourceMappingURL=flag-loading.js.map